import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { ButtonReset } from '@fenderdigital/ui/utils/css';

export const Presets = styled.div`
  margin-top: 16px;
  width: 100%;
  max-width: 688px;
`;

export const Preset = styled.div`
  align-content: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 8px 0;
`;

export const PresetIconContainer = styled.div`
  align-content: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PresetIcon = styled.div`
  border-radius: 10px;
  height: 48px;
  overflow: hidden;
  width: 48px;
`;

export const PresetMetadata = styled.div`
  align-content: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  margin-left: 16px;
`;

export const PresetTitle = styled.p`
  font-family: SourceSansPro-Bold;
  font-size: 16px;
  font-weight: normal;
  margin-bottom: 0;
`;

export const PresetDescription = styled.p`
  color: rgb(74, 74, 74);
  font-size: 14px;
  padding-right: 8px;
  margin-bottom: 0;
`;

export const MobileDownloadButton = styled.button`
  ${ButtonReset};
  align-content: center;
  background-color: ${({ theme }): string => theme.colors.red};
  border-radius: 18px;
  color: rgb(255, 255, 255);
  cursor: pointer;
  display: grid;
  height: 36px;
  justify-content: center;
  padding: 0;
  width: 36px;
`;

export const PresetDownloadButtonText = styled.span`
  display: none;
  font-family: FuturaPT-Heavy;
  font-weight: normal;
  ${up('tablet-portrait')} {
    display: inline;
    margin-left: 16px;
  }
`;

export const PresetDivider = styled.div`
  background-color: rgb(224, 224, 224);
  height: 1px;
  margin-left: 64px;
  ${up('tablet-portrait')} {
    display: none;
  }
`;

export const Container = styled.div`
  background-color: #f0f1f2;
  border: 2px solid #e8e9e9;
  border-radius: 10px;
  margin: 24px 0;
  padding: 16px;
  max-width: 688px;
`;

export const Title = styled.h3`
  font-family: FuturaPT-Heavy;
  font-size: 24px;
  margin: 10px 0 16px 0;
  text-align: center;
`;

export const InstructionItem = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 32px;
`;

export const InstructionCount = styled.div`
  align-items: center;
  background: #dedfe1;
  border-radius: 100%;
  display: flex;
  font-family: FuturaPT-Heavy;
  font-weight: normal;
  font-size: 16px;
  justify-content: center;
  line-height: 0;
  margin-right: 16px;
  padding-top: 2px;
  height: 28px;
  width: 28px;
`;

export const InstructionText = styled.p`
  flex: 1;
  font-family: SourceSansPro-Regular;
  font-weight: normal;
  padding-top: 5px;
  margin-bottom: 0;
  strong {
    font-family: SourceSansPro-Bold;
    font-weight: normal;
  }
`;

export const StartPlaying = styled.strong`
  display: block;
  font-family: SourceSansPro-Bold;
  font-weight: normal;
  padding-bottom: 24px;
`;

export const ContainerFooter = styled.div`
  border-top: 1px solid rgb(224, 224, 224);
  padding-top: 24px;
  strong {
    font-family: SourceSansPro-Bold;
    font-weight: normal;
  }
`;

export const Link = styled.a`
  color: rgb(2, 140, 201);
  font-family: SourceSansPro-Bold;
  font-weight: normal;
  text-decoration: none;
`;

export const AmpsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 12px;
  @media screen and (max-width: 688px) {
    &:nth-of-type(2) {
      margin-bottom: 0;
    }
    .GT-200 {
      display: none;
    }
  }
`;

export const Amp = styled.div`
  height: 136px;
  margin: 0 16px 32px 16px;
  text-align: center;
  width: 136px;
  strong {
    font-family: SourceSansPro-Bold;
    font-weight: normal;
  }
`;

export const ToneAppContainer = styled.div`
  width: 100%;
  max-width: 688px;
`;

export const ToneAppHeader = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 40px;
`;

export const ToneAppIcon = styled.div`
  border-radius: 10px;
  height: 64px;
  overflow: hidden;
  width: 64px;
`;

export const ToneAppMetadata = styled.div`
  flex: 1;
  margin-left: 16px;
`;

export const ToneAppTitle = styled.h4`
  font-family: FuturaPT-Heavy;
  font-size: 24px;
  margin: 0;
`;

export const ToneAppDescription = styled.p`
  font-size: 14px;
  margin-bottom: 0;
`;

export const ToneAppBody = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  ${up('tablet-portrait')} {
    flex-direction: row;
  }
`;

export const ToneAppUpsellImage = styled.div`
  ${up('tablet-portrait')} {
    flex: 1;
  }
`;

export const ToneAppUpsellContent = styled.div`
  ul {
    margin: 24px 0;
  }
  li {
    margin: 12px 0;
  }
  ${up('tablet-portrait')} {
    flex: 1;
    ul {
      margin-top: 12px;
    }
  }
`;

export const AppStoreButtons = styled.div`
  ${up('tablet-portrait')} {
    margin-left: 16px;
  }
`;
